import { computed, defineComponent, inject, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import Quantity from "../../Shared/Quantity";
import Markdown from "../../Shared/Markdown";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";
import { priceFormatterKey } from "../../../infrastructure/price_formatter";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

export default defineComponent({
  template: html,
  components: { Quantity, Markdown },
  emits: {
    next: () => true,
  },
  setup() {
    const { t } = useI18n();
    const orderService = inject(orderServiceKey);
    const priceFormatter = inject(priceFormatterKey)

    // variables and computed
    const boxesWanted = ref(false);
    const currentQuantity = computed(() => {
      return (
        orderService?.currentItems?.value?.reduce((sum, it) => {
          if (it.product_id == productId) {
            sum = sum + it.qty;
          }
          return sum;
        }, 0) ?? 0
      );
    });
    const variant = computed(()=> {
      const baseVariant = orderService?.availableVariants?.value?.find(
        (v) => v.product_id == productId && v.qty_price_for == 0,
      );
      return baseVariant ?? null;
    })
    const productId: number = 9;
    const vatType = computed(() => {
      return orderService?.currentVatType.value;
    });

    // methods
    const handleQuantityChange = async (qty: number) => {
      const diff: number = qty - currentQuantity.value ;
      if (diff > 0){
        await orderService?.addToCart(variant?.value?.id ?? 0, '', diff);
      } else {
        await orderService?.removeFromCart(variant?.value?.id ?? 0, '', (-1) * diff);
      }
    };
    const boxesWantedToggle = async () => {
      if (false == boxesWanted.value) {
        const toRemove =
          orderService?.currentItems?.value?.filter(
            (it) => it.product_id == productId,
          ) ?? [];
        for (let i = 0; i < toRemove.length; i++) {
          await orderService?.removeFromCart(
            toRemove[i].product_variant_id,
            "",
            toRemove[i].qty,
          );
        }
      } else {
        await orderService?.addToCart(variant?.value?.id ?? 0, '', 1);
      }
    };

    onMounted(() => {
      const hasBoxes =
        orderService?.currentItems?.value?.filter(
          (it) => it.product_id == productId,
        ).length ?? 0;
      if (0 < hasBoxes) {
        boxesWanted.value = true;
      }
    });

    return {
      currentQuantity,
      boxesWanted,
      variant,
      t,
      boxesWantedToggle,
      handleQuantityChange,
      priceFormatter,
      vatType,
    };
  },
} as any);
